import { BehaviorSubject } from 'rxjs';

const stateSubject = new BehaviorSubject({});

export const stateService = {
    // Observable that components can subscribe to for getting the state
    getState: () => stateSubject.asObservable(),

    setState: (key, value) => {
        const currentState = stateSubject.getValue(); 
        const updatedState = Object.assign({}, currentState);
        updatedState[key] = Object.assign({}, currentState[key] || {}, value);
        stateSubject.next(updatedState);
    },

    currentState: () => stateSubject.getValue(),

    getItem: (key) => {
        const currentState = stateSubject.getValue(); 
        return currentState[key]; 
    },
};
